import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

// 환경변수 확인 (개발 시에만)
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Environment Variables:');
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('VUE_APP_USE_MOCK_EXCEL_TEMPLATES:', process.env.VUE_APP_USE_MOCK_EXCEL_TEMPLATES);
  console.log('VUE_APP_USE_MOCK_DATA:', process.env.VUE_APP_USE_MOCK_DATA);
  console.log('VUE_APP_MOCK_DELAY:', process.env.VUE_APP_MOCK_DELAY);
  console.log('VUE_APP_API_URL:', process.env.VUE_APP_API_URL);
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
